{
  "oneUpgrade": {
    "errors": {
      "ticketNotIssued": {
        "heading": "Korotuksia ei ole vielä saatavilla",
        "paragraph": "Kirjoitamme vielä lippujasi. Tarkista korotusten saatavuus, kun olet saanut liput sähköpostiisi."
      }
    }
  },
  "ondMarketing": {
    "breadcrumb": {
      "flights": "Lennot",
      "fromCity": "Lennot kaupungeista",
      "cityToCity": "Lennot kaupungista kaupunkiin",
      "fromCountry": "Lennot maista",
      "countryToCountry": "Lennot maasta maahan"
    },
    "heading": {
      "flights": "Tutustu lentoihimme ja kohteisiimme",
      "fromCity": "Lennot kaupungeista",
      "cityToCity": "Löydä lisää lentoja ja matkakohteita",
      "fromCountry": "Lennot maista",
      "countryToCountry": "Löydä lisää lentoja ja matkakohteita"
    },
    "flightsFrom": "Lennot kohteesta {origin}",
    "destinationFlightInfo": {
      "startingFrom": "Alkaen",
      "roundTrip": "Meno-paluu",
      "oneWay": "Yhdensuuntainen",
      "flightTime": "Lentoaika",
      "approx": "Noin",
      "airports": "Lentoasemat",
      "directFlights": "Suorat lennot",
      "frequency": {
        "unit": {
          "day": "/ päivä",
          "week": "/ viikko"
        },
        "perDay": {
          "singular": "1 lento päivässä",
          "plural": "{count} lentoa päivässä"
        },
        "perWeek": {
          "singular": "1 lento viikossa",
          "plural": "{count} lentoa viikossa"
        }
      }
    },
    "destinationPromotion": {
      "title": "Tutustu kohteeseen {destination}",
      "description": {
        "direct": "Finnairin lennot reitillä {origin}–{destination} lähtevät  {frequency}. Lentoaika on noin {duration}.",
        "connecting": "Lennot reitillä {origin}–{destination} sisältävät kätevän vaihtoyhteyden Helsinki-Vantaan lentokentällä. Matka-aika on noin {duration}.",
        "basic": "Varaa lennot reitille {origin}–{destination} ja tutustu kaikkeen, mitä matkakohde tarjoaa.",
        "destinationPage": " Kiinnostaako {destination}? Löydä vinkkejä ja ideoita matkallesi."
      },
      "frequency": {
        "perDay": {
          "singular": "kerran päivässä",
          "plural": "{count} kertaa päivässä"
        },
        "perWeek": {
          "singular": "kerran viikossa",
          "plural": "{count} kertaa viikossa"
        }
      }
    },
    "fromTo": "{origin}–{destination}"
  }
}
